<template>
  <div class="article-detail center-block">
    <div class="article-detail_main">
      <div class="colorBorder">
        <article-area :isArticle="isArticle" :articleItem="articleItem"/>
      </div>
      <div v-if="articleItem.auditState === 'PASS'" class="article-detail_main-comment colorBorder">
        <Comment :articleItem="articleItem"/>
      </div>
      <div style="height: 20px;"></div>
    </div>
    <div class="article-detail_side">
      <user-profile 
        :userId="articleItem.authorInfo.userId"
        :userName="articleItem.authorInfo.userName" 
        :headUrl="articleItem.authorInfo.headUrl" 
        :articleTotal="articleItem.authorInfo.articleTotal" />
      <hot-article />
    </div>
  </div>
</template>

<script>
import ArticleArea from './components/ArticleArea.vue'
import Comment from './components/Comment.vue'
import HotArticle from '@/components/HotArticle.vue'
import UserProfile from '@/components/UserProfile.vue'
import { getDetail } from '@/utils/api.js'

export default {
  components: {
    ArticleArea,
    Comment,
    HotArticle,
    UserProfile
  },
  data() {
    return {
      articleItem: {
        bugStatus: 'UNRESOLVED',
        title: '',
        authorInfo: {
          userId: '',
          headUrl: '',
          userName: ''
        },
        auditState: 'WAIT', //审核状态:WAIT：待审核，PASS：审核通过，REJECT：审核拒绝
        createTime: '',
        views: 0,
        comments: 0,
        tagList: [
        ],
        content: '',
      }
    }
  },
  computed: {
    postsId() {
      return this.$route.params.id
    },
    isArticle() {
      return this.$route.path.indexOf('article-detail') > -1
    }

  },
  created() {
    getDetail(this.postsId).then(res => {
      if (res.code === 0) {
        this.articleItem = res.data
      } else {
        this.$message.error('获取详情失败')
      }
    })
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.colorBorder {
  background: #fff;
  border: 1px solid rgba(229,230,233,1);
}
::-webkit-scrollbar {
  width: 0 !important;height: 0;
}
.article-detail {
  max-height: 100%;
  display: flex;
  padding-top: 10px;
  overflow-y: auto;
  &_main {
    flex: 1;
    &-comment {
      margin-top: 10px;
    }
  }
  &_side {
    margin-left: 10px;
    width: 295px;
    flex: 0 0 295px;
  }
}
</style>